<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Antecedentes no penales</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Antecedentes' }, { label: 'No penal' }]" />
    </div>
  </section>

  <section wrapper>
    <div [formGroup]="formUpload" class="page-section card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <label>Generar Constancia.</label>
        <p-button label="Generar Constancia" [loading]="isSaving" (onClick)="generate()" [disabled]="!this.formUpload.valid" />
      </div>

      <div class="card-body d-flex flex-column gap-2">
        <div class="d-flex gap-3">
          <div class="d-flex flex-column" style="width: 134px; height: 134px">
            <preview-upload-image
              [image]="photo.value"
              imageSrc="./assets/images/person-placeholder.jpg"
              [ngClass]="{ 'border border-danger border-4 rounded-2': photo.value?.size > this.maxSizesUpload }"
            >
              <input #input (change)="onPhotoChanged($event)" type="file" style="line-height: 2.6" accept="image/*" />
            </preview-upload-image>
          </div>

          <div class="col-4 w-auto">
            <div class="mb-3 flex flex-column gap-2">
              <input placeholder="Nombre completo" formControlName="name" type="text" pInputText class="w-100 h-50px" />
              <small class="ps-2"><span class="text-danger">Requerido *</span></small>
            </div>

            <div class="d-flex align-items-center gap-4">
              <p-selectbutton [options]="fingerprintOptions" formControlName="fingerprint" optionLabel="label" optionValue="value" />
            </div>
          </div>
        </div>
        <div>
          <small class="ps-2 d-block text-danger">Requerido *</small>
          @if (photo.value?.size > this.maxSizesUpload) {
          <small class="px-2 d-block text-danger">El tamaño de la imagen no debe ser mayor a 2mb.</small>
          }
          <small class="ps-2 d-block">Formatos JPG, JPEG y PNG. Tamaño máximo 2mb.</small>
        </div>
      </div>
    </div>

    <div class="page-section card">
      <div class="card-body p-0">
        <p-table #dt1 [value]="this.list" dataKey="id" [rows]="25" [showCurrentPageReport]="true" [rowsPerPageOptions]="[25, 50, 100]" [paginator]="true" [globalFilterFields]="['name']">
          <ng-template pTemplate="caption">
            <p-inputgroup>
              <p-iconfield class="w-100">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText [(ngModel)]="searchValue" (input)="dt1.filterGlobal(searchValue, 'contains')" placeholder="Buscar por nombre." class="w-100 h-50px rounded-end-0" />
              </p-iconfield>
              <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
              </p-inputgroup-addon>
            </p-inputgroup>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>Nombre</th>
              <th colspan="2">FECHA</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td class="text-nowrap">{{ item.name }}</td>
              <td class="text-nowrap">{{ item.dateCreated | date : "longDate" }}</td>
              <td class="text-nowrap text-end">
                @if (item.download === 0) {
                <a
                  href="{{ apiUrl }}/v1/antecedente/no-penal/download/{{ item.foil }}"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  class="p-button text-decoration-none p-button-success"
                  (click)="item.download = 1"
                >
                  <i class="pi pi-download"></i>
                </a>
                } @else {
                <a href="{{ apiUrl }}/v1/antecedente/no-penal/download/{{ item.foil }}" download target="_blank" rel="noopener noreferrer" class="p-button text-decoration-none">
                  <i class="pi pi-download"></i>
                </a>
                }
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="3">No se encontraron registros.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </section>
</backbone>
